var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mess_box" },
    [
      _c(
        "vab-collapse",
        { staticClass: "message_collapse", attrs: { title: _vm.title } },
        _vm._l(_vm.list, function (item, index) {
          return _c("div", { key: index, staticClass: "me_item flex_start" }, [
            _c("span", { staticClass: "time" }, [
              _vm._v(_vm._s(item.adjScheduleStatusDatetime)),
            ]),
            _c("div", { staticClass: "me_inner flex_colum" }, [
              _c("div", { staticClass: "flex_start flex_center_align" }, [
                _c("img", {
                  attrs: { src: require("@/assets/images/r9.png"), alt: "" },
                }),
                _c("span", { staticClass: "word" }, [
                  _vm._v(" " + _vm._s(_vm.getMessageCompanyName(item)) + " "),
                ]),
              ]),
              _c("div", { staticClass: "state_box flex_colum" }, [
                item.adjScheduleStatus || item.docSubmitStatus
                  ? _c("div", { staticClass: "flex_start" }, [
                      _vm.isEqualCodeEnum(
                        item.adjScheduleStatus
                          ? item.adjScheduleStatus
                          : item.docSubmitStatus,
                        _vm.$divisions.adjScheduleStatusEnum.enum_5
                      )
                        ? _c("div", { staticClass: "img_box2" }, [
                            _c("img", {
                              staticClass: "common_img",
                              attrs: {
                                src: require("@/assets/images/r11.png"),
                                alt: "",
                              },
                            }),
                          ])
                        : _c("div", { staticClass: "img_box" }, [
                            _c("img", {
                              staticClass: "common_img",
                              attrs: {
                                src: require("@/assets/images/r10.png"),
                                alt: "",
                              },
                            }),
                          ]),
                      _c("span", { staticClass: "state_word" }, [
                        _c(
                          "div",
                          {
                            class: {
                              error: _vm.isEqualCodeEnum(
                                item.adjScheduleStatus
                                  ? item.adjScheduleStatus
                                  : item.docSubmitStatus,
                                _vm.$divisions.adjScheduleStatusEnum.enum_5
                              ),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.adjScheduleStatus
                                    ? _vm.getEnumText(
                                        item.adjScheduleStatus,
                                        _vm.$divisions.adjScheduleStatusEnum
                                      )
                                    : _vm.getEnumText(
                                        item.docSubmitStatus,
                                        _vm.$divisions.docSubmitStatusEnum
                                      )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
                item.submitRemarks || item.confirmRemarks
                  ? _c("div", { staticClass: "tichu pre_wrap" }, [
                      _vm._v(
                        " " +
                          _vm._s(item.submitRemarks || item.confirmRemarks) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }